import React from 'react';
import {
  Header,
  Footer,

  MedalliaFeedback,
} from '@chr/navisphereonline-shared-components';
import { LoggingErrorBoundary } from '@chr/common-javascript-logging-error-boundary';
import { ErrorPage } from './common/components/errors/ErrorPage';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './AppRoutes';
import { LocalizationProvider, SnackbarProvider } from '@chr/eds-react';
import { AppConfig } from 'react-app-env';
import { Provider as ReduxProvider } from 'react-redux';
import { Store } from 'redux';
import { OnlineLDProvider } from './common/components/launchDarkly/OnlineLDProvider';

export interface AppProps {
  store: Store;
  config: AppConfig;
}

export const App = ({ store, config }: AppProps) => {
  const routerBaseName = document.baseURI.substring(
    document.baseURI.indexOf(window.location.origin) +
    window.location.origin.length,
    document.baseURI.lastIndexOf('/')
  );

  return (
    <>
      <MedalliaFeedback />
      <LoggingErrorBoundary render={ErrorPage}>
        <SnackbarProvider>
          <LocalizationProvider>
           
            <Header />
            <OnlineLDProvider config={config}>
              <ReduxProvider store={store}>
                <BrowserRouter basename={routerBaseName}>
                  <AppRoutes />
                </BrowserRouter>
              </ReduxProvider>
            </OnlineLDProvider>
            <Footer />
          </LocalizationProvider>
        </SnackbarProvider>
      </LoggingErrorBoundary>
    </>
  );
};

export default App;
